//Importación de librerias
import Tablero from '../../src/components/Tablero/Plantilla.vue'
import Forseti from '../../src/components/Forseti/Comun/Plantilla.vue'


//Creamos la variable de plantillas
const plantillas = {};


//Asignamos los datos necesarios del plantillas
plantillas.Tablero = Tablero;
plantillas.Forseti = Forseti;


//Exportamos los datos de plantillas
export default plantillas;



//////////////////
// WEBPACK FOOTER
// ./static/js/plantillas.js
// module id = null
// module chunks = 